import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {PromotionCounterModule} from '@gongxigames/framework/slot/modules/promotionsCounter';
import {PromotionCounterView} from '@gongxigames/framework/slot/modules/promotionsCounter/PromotionCounterView';
import {CounterData} from '@gongxigames/framework/slot/events/StrictPromotionEvents';

export class PromotionCounterBasicState extends ModuleState<PromotionCounterView, PromotionCounterModule> {
    public onEnterState(): void {}

    public onLeaveState(): void {}

    protected setupEvents(): void {
        this.setEventHandler('General.Promotion.ActivateCounter', this.onActivateCounter.bind(this));
    }

    protected onActivateCounter(data: CounterData): void {
        this.view.updateCounter(data);
        this.module.gotoState(PromotionCounterModule.ACTIVE_STATE);
    }
}
